import React, { useState, useEffect, lazy } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentLanguage } from 'globalutils/commonUtils';
import { downloadFile } from './util';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const ExportPopup = ({ isOpen, setIsOpen, Styled, logBook, getDocumentToken }) => {
  const history = useHistory();
  const query = new URLSearchParams(history.location.search);
  const beBaseUrl = window?.$environment?.BE_BASE_URL;
  const i18n = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      clickedModal1();
    }
  }, [isOpen]);

  const handleExportAsCsv = async () => {
    try {
      if (getDocumentToken) getDocumentToken({ apiId: 'exportUser' });

      let pageUrl = '/violations/exportNonDeletedViolations?token=';
      if (window.location.href.includes('alerts')) {
        pageUrl = '/alerts/export/CSV?token=';
      } else if (window.location.href.includes('driverStatus')) {
        pageUrl = `/driverStatus/export/CSV?id=${query.get('id')}&token=`;
      }

      const url = `${beBaseUrl}${pageUrl}${logBook.documentToken}`;
      await downloadFile(url, 'file.csv');
    } catch (error) {
      console.error('Failed to export CSV:', error);
    } finally {
      closeModal1();
    }
  };

  const handleExportAsPdf = async () => {
    try {
      if (getDocumentToken) getDocumentToken({ apiId: 'exportUser' });

      let pageUrl = '/violations/exportNonDeletedViolations/pdf?token=';
      if (window.location.href.includes('alerts')) {
        pageUrl = '/alerts/export/PDF?token=';
      } else if (window.location.href.includes('driverStatus')) {
        pageUrl = `/driverStatus/export/PDF?id=${query.get('id')}&token=`;
      }

      const url = `${beBaseUrl}${pageUrl}${logBook.documentToken}`;
      await downloadFile(url, 'file.pdf');
    } catch (error) {
      console.error('Failed to export PDF:', error);
    } finally {
      closeModal1();
    }
  };

  const handleExportPrint = () => {
    getDocumentToken && getDocumentToken({ apiId: 'exportUser' });
    const languageParam = getCurrentLanguage();

    const pageurl = (() => {
      if (window.location.href.includes('alerts')) {
        return 'alerts?';
      } else if (window.location.href.includes('driverStatus')) {
        return `driving/status?id=${query.get('id')}&`;
      }
      return 'violations?';
    })();

    const printUrl =
      beBaseUrl + `/document/html/print/${pageurl}` + 'token=' + logBook.documentToken + '&language=' + languageParam;
    const pdfWindow = window.open(printUrl);
    pdfWindow.focus();
  };

  const closeModal1 = () => {
    setIsOpen(false);
    setOpen(false);
  };

  const clickedModal1 = () => {
    setOpen(true);
  };

  return (
    <>
      {isOpen && (
        <Modal
          open={open}
          setOpen={setOpen}
          data={{
            content: () => {
              return (
                <Styled.ExportOptionWrapper>
                  <Link
                    onClick={() => {
                      handleExportAsCsv();
                    }}
                  >
                    {' '}
                    CSV
                  </Link>
                  <Link
                    onClick={() => {
                      handleExportAsPdf();
                    }}
                  >
                    {' '}
                    PDF
                  </Link>
                  <Link
                    onClick={() => {
                      handleExportPrint();
                    }}
                  >
                    {i18n.t('Print')}
                  </Link>
                </Styled.ExportOptionWrapper>
              );
            },
          }}
          isExportPopup
          onClose={() => {
            setIsOpen(false);
          }}
          className="modalExport"
        />
      )}
    </>
  );
};

export default ExportPopup;
